export default __webpack_public_path__ + "static/media/kw.584cd93f.svg";